var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPausedLarge = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 44,
  viewBox: "0 0 44 44",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 44,
  height: 44,
  rx: 22,
  fill: "currentColor"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20 17.5C20 16.6716 19.3284 16 18.5 16C17.6716 16 17 16.6716 17 17.5V26.5C17 27.3284 17.6716 28 18.5 28C19.3284 28 20 27.3284 20 26.5L20 17.5ZM27 17.5C27 16.6716 26.3284 16 25.5 16C24.6716 16 24 16.6716 24 17.5L24 26.5C24 27.3284 24.6716 28 25.5 28C26.3284 28 27 27.3284 27 26.5V17.5Z",
  fill: "white"
})));
export default SvgPausedLarge;